<template>
  <div>
    <!--头部搜索框-->
    <b-row align-h="between" class="mt-3 mb-3">
      <b-col cols="12">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              type="search"
              v-model="searchForm.searchKeyWord"
              placeholder="Search here..."
              @keyup.enter="keySearch"
            />
            <b-input-group-append>
              <b-button-group>
                <!-- <b-dropdown right variant="light" ref="dropdown">
                  <b-dd-form :inline="true" style="width: 350px;">
                    <h6>Filter by</h6>
                    <b-form-row class="mt-1 mb-2">
                      <b-col md="12" lg="12">
                        <b-form-group label="全部状态">
                          <bv-select
                            v-model="searchForm.prjStatus"
                            size="md"
                            url="/digitalCenter/common/dict/system"
                            :params="{ dictType: 'prjStatus' }"
                          ></bv-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col style="text-align:center;">
                        <b-button block @click="subSearch" variant="primary">Search</b-button>
                        <b-button block @click="subReset" variant="outline-primary">Reset</b-button>
                      </b-col>
                    </b-form-row>
                  </b-dd-form>
                </b-dropdown>-->
                <b-button
                  variant="primary"
                  @click="keySearch"
                  size="sm"
                  class="my-2 my-sm-0"
                >
                  <i class="fa fa-search"></i>
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <!--子项目表格-->
    <b-table
      :busy="isBusy"
      :fields="tableFields"
      :items="tableData"
      thead-class="hidden-header"
      class="bg-white"
      hover
    >
      <template v-slot:cell(operation)="data">
        <b-button-group>
          <b-button
            v-b-tooltip.hover
            :title="$l('tips_view') || '查看'"
            class="mr-2"
            variant="outline-secondary"
            @click="fromLoad('detail', data.item.prjCode)"
            size="sm"
          >
            <b-icon-eye></b-icon-eye>
          </b-button>
          <b-button
            v-b-tooltip.hover
            :title="$l('tips_edit') || '编辑'"
            variant="outline-secondary"
            size="sm"
            v-if="data.item.isPrjEdit === 'Y'"
            @click="fromLoad('edit', data.item.prjCode)"
          >
            <b-icon-pencil></b-icon-pencil>
          </b-button>
        </b-button-group>
      </template>
      <template v-slot:cell(prjTitle)="data">
        <span style="font-size: 14px; font-weight: 400">{{
          data.item.prjTitle ? data.item.prjTitle : "--"
        }}</span>
        <br />
        <span>
          <small
            >{{ $l("label_period") || "项目周期" }}：{{
              data.item.beginDate
            }}-{{ data.item.endDate }}</small
          >
        </span>
      </template>
      <template v-slot:cell(prjSchedule)="data">
        <b-badge
          class="mb-1"
          :variant="
            data.item.prjStatus === 'Y'
              ? 'success'
              : data.item.prjStatus === 'P'
              ? 'info'
              : data.item.prjStatus === 'D'
              ? 'danger'
              : data.item.prjStatus === 'C'
              ? 'warning'
              : data.item.prjStatus === 'F'
              ? 'secondary'
              : data.item.prjStatus === 'S'
              ? 'secondary'
              : ''
          "
        >
          {{
            data.item.prjStatus === "Y"
              ? $l("label_completed") || "已完成"
              : data.item.prjStatus === "P"
              ? $l("label_in_progress") || "进行中"
              : data.item.prjStatus === "D"
              ? $l("label_out_dated") || "已超期"
              : data.item.prjStatus === "C"
              ? $l("label_terminated") || "已终止"
              : data.item.prjStatus === "F"
              ? $l("label_deleted") || "已删除"
              : data.item.prjStatus === "S"
              ? $l("label_draft") || "草稿"
              : ""
          }}
        </b-badge>
        <b-progress
          :variant="
            data.item.prjStatus === 'Y'
              ? 'success'
              : data.item.prjStatus === 'P'
              ? 'info'
              : data.item.prjStatus === 'D'
              ? 'danger'
              : data.item.prjStatus === 'C'
              ? 'warning'
              : data.item.prjStatus === 'F'
              ? 'secondary'
              : data.item.prjStatus === 'S'
              ? 'secondary'
              : ''
          "
          height="0.3rem"
          style="width: 95%"
          :value="data.item.prjSchedule"
          :max="max"
          animated
        ></b-progress>
        <p style="font-size: 13px">
          Progress with: {{ data.item.prjSchedule }}%
        </p>
      </template>
      <template v-slot:cell(principal)="data">
        <b-avatar class="mr-3" :src="data.item.prjOwnerImgUrl"></b-avatar>
        <span class="mr-auto">{{ data.item.prjOwnerCodeName }}</span>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
    <js-pagination
      v-if="!isEmpty"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      align="right"
      size="sm"
      @change="subProjectPageChange"
    />
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    params: {
      default: null,
      type: Object,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    autoLoad: {
      default: false,
      type: Boolean,
    },
    height: {
      default: 272,
      type: Number,
    },
  },
  watch: {
    params: {
      handler() {
        if (this.autoLoad) {
          this.init(this.params);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isEmpty: false,
      isBusy: false,
      max: 100,
      searchForm: {
        prjCode: "",
        searchKeyWord: "",
        prjStatus: "",
        prjStatusList: [],
      },
      tableData: [],
      tableFields: [
        {
          key: "operation",
          label: "操作",
          tdClass: "align-middle",
        },
        {
          key: "prjTitle",
          label: "项目名称",
          tdClass: "align-middle",
        },
        {
          key: "prjSchedule",
          label: "进度",
          tdClass: "align-middle w-25",
        },
        {
          key: "principal",
          label: "负责人",
          tdClass: "align-middle",
        },
      ],
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0,
      },
    };
  },
  methods: {
    load(params) {
      this.init(params);
    },
    init(params) {
      if (params.prjCode === "") {
        return;
      }
      this.searchForm.prjCode = params.prjCode;
      this.page.pageTotal = 0;
      this.page.curPage = 1;
      this.page.pageSize = 5;
      this.getData(params);
    },
    getData(params) {
      this.isBusy = true;
      this.$api
        .projectInfoSubPrjectListApi({
          ...(params || this.params),
          ...this.page,
        })
        .then((res) => {
          this.isBusy = false;
          let totalCount = res.body.count;
          this.tableData = res.body.data;
          if (totalCount > 0) {
            this.isEmpty = false;
            this.page.pageTotal = res.body.count;
            this.page.curPage = res.body.curPage;
            this.page.pageSize = res.body.pageSize;
          } else {
            this.isEmpty = true;
          }
        })
        .catch(() => {
          this.isBusy = false;
        });
    },
    keySearch() {
      this.getData(this.searchForm);
    },
    subSearch() {
      this.searchForm.prjStatusList = [];
      if (this.searchForm.prjStatus) {
        this.searchForm.prjStatusList.push(this.searchForm.prjStatus);
      }
      this.getData(this.searchForm);
    },
    subReset() {
      this.searchForm.searchKeyWord = "";
      this.searchForm.prjStatusList = [];
      this.getData(this.searchForm);
    },
    // 子项目列表分页查询
    subProjectPageChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      };
      this.getData(this.searchForm);
    },
    // 加载表单
    fromLoad(ref, val) {
      if (ref === "edit") {
        this.$router.push({
          name: "projectManagement-projectInfo-edit",
          params: {
            pageType: ref,
            prjCode: val,
          },
        });
      } else {
        this.$router.push({
          name: "projectManagement-projectInfo-detail",
          params: {
            pageType: ref,
            prjCode: val,
          },
        });
      }
    },
  },
};
</script>
